import React, { useContext, useEffect } from "react";
import { useTheme } from "emotion-theming";
import { NewAddressContext } from "wrapper/NewAddressWrapper/context/newAddressContext";
import { AddressImportedSuccessWarpper, Main, Wrapper } from "./assets/style";
import MobHeader from "components/NewMobHeader";
import { ImportAddressCard } from "./components/ImportAddressCard";
import { FilledButton } from "@nykaa/payment-ui/src/Button";
import { BottomSheet } from "@nykaa/payment-ui/src/BottomSheet/BottomSheet";
import { ICONS } from "helpers/utils/getIcons";
import { Text } from "@nykaa/payment-ui/src/Text";
import { Icon } from "@nykaa/payment-ui/src/Icon";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { trackImportAddressPageLoads } from "wrapper/NewAddressWrapper/dependencies/tracking";
import { PAGE_NAMES } from "../../constants";

const ImportAddress = () => {
  const theme: Theme = useTheme();
  const newAddressContext: any = useContext(NewAddressContext);
  const headerTitle = newAddressContext?.importAddressHeaderTitle;
  const handleBackButton = newAddressContext?.handleBackButton;
  const importedAddresses = newAddressContext?.importedAddresses;
  const handleImportCheckBoxClick = newAddressContext?.handleImportCheckBoxClick;
  const handleImportAndSaveAddressClick = newAddressContext?.handleImportAndSaveAddressClick;
  const isImportButtonDisabled = newAddressContext?.isImportButtonDisabled;
  const showAddressImportedSuccessBottomSheet = newAddressContext?.showAddressImportedSuccessBottomSheet;
  const handleCloseImportedAddressBottomSheet = newAddressContext?.handleCloseImportedAddressBottomSheet;
  const importSuccessMessage = newAddressContext?.importSuccessMessage;

  const addressImportedSuccessSubtitle = getStringFromId(
    VERNACULAR_STRING_IDS.ADDRESS_IMPORTED_SUCCESS_SUBTITLE,
    VERNACULAR_DEFAULT_MESSAGES.ADDRESS_IMPORTED_SUCCESS_SUBTITLE
  );

  useEffect(() => {
    const numberOfAddress = importedAddresses?.length
    if(numberOfAddress) {
      trackImportAddressPageLoads({
        no_of_address_present: numberOfAddress,
        interaction_location: PAGE_NAMES.CHECKOUT_FLOW_ADDRESS,
      });
    }
  }, [importedAddresses])
  
  return (
    <div>
      <Wrapper>
        <MobHeader
          title={headerTitle}
          onIconClick={handleBackButton}
          fixAtTop
          dataTestId="back_button"
        />
        <Main className="layout vertical">
          <div className="layout vertical justified" data-testid="saved_address_list">
            {importedAddresses?.map((address: ImportAddressDataType, index: number) => {
              return (
                <ImportAddressCard
                  isDefault={false}
                  // tag={}
                  isChecked={address.isChecked}
                  address={address}
                  key={index}
                  handleCheckBoxClick={handleImportCheckBoxClick}
                />
              );
            })}
          </div>
          <div className="layout vertical bottom-fixed">
            <div className="ptb16">
              <FilledButton
                text={headerTitle}
                onClick={handleImportAndSaveAddressClick}
                theme={theme}
                isDisabled={isImportButtonDisabled}
                dataTestId="button_import_address_and_save"
              />
            </div>
          </div>
        </Main>
        <BottomSheet
          isVisible={showAddressImportedSuccessBottomSheet}
          icon={ICONS.CLEAR}
          onClose={handleCloseImportedAddressBottomSheet}
          onIconClick={handleCloseImportedAddressBottomSheet}
          theme={theme}
          maxHeight={85}
          dataTestId="address_imported_success"
        >
          <AddressImportedSuccessWarpper>
            <div className="success-icon">
              <Icon icon={ICONS.SUCCESS_TICK} />
            </div>
            <Text 
              text={importSuccessMessage} 
              color={getHexToRgba(theme.colors.textPrimary, 0.92)}
              font={theme.typography.titleMedium} 
              theme={theme} 
            />
            <Text 
              text={addressImportedSuccessSubtitle} 
              color={theme?.colors?.textPrimary064}
              font={theme.typography.bodyMedium} 
              theme={theme} 
            />
          </AddressImportedSuccessWarpper>
        </BottomSheet>
      </Wrapper>
    </div>
  );
};

export default ImportAddress;
